import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatSnackBar} from '@angular/material/snack-bar';
import {OrganisationStore} from '../../../stores/organisation.store';

/**
 * Toolbar dropdown for switching between the current user's organisations.
 * Hidden when the user only belongs to one org. Disabled while a switch is
 * in flight (matches `OrganisationStore.isSwitchingOrg`).
 */
@Component({
  selector: 'app-org-switcher',
  imports: [MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './org-switcher.component.html',
  styleUrl: './org-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrgSwitcherComponent {
  private readonly orgStore = inject(OrganisationStore);
  private readonly snackBar = inject(MatSnackBar);

  readonly visible = computed(() => this.orgStore.organisations().length > 1);
  readonly currentName = computed(() => this.orgStore.selectedOrganisation()?.name ?? '');
  readonly currentOrgId = computed(() => this.orgStore.selectedOrganisationId());
  readonly organisations = this.orgStore.organisations;
  readonly disabled = this.orgStore.isSwitchingOrg;

  switch(orgId: number): void {
    if (orgId === this.currentOrgId()) return;
    // switchTo rethrows on failure (after best-effort sub-store restore).
    // Surface a snackbar so the user sees something went wrong, and trap
    // here so the error doesn't bubble out as an unhandled RxJS error.
    this.orgStore.switchTo(orgId).subscribe({
      error: () => this.snackBar.open('Failed to switch organisation. Please try again.', 'OK', {duration: 5000}),
    });
  }
}
